import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { cleanRut } from 'rutlib/lib';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';

@Component({
  selector: 'app-lista-finiquitos',
  templateUrl: './lista-finiquitos.component.html',
  styleUrls: ['./lista-finiquitos.component.css'],
  providers: [DatePipe],
})
export class ListaFiniquitosComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';
  constructor(
    private modalService: NgbModal,
    private trabajadoresService: TrabajadoresService,
    private _liveAnnouncer: LiveAnnouncer
  ) {
    this.uploader.onSuccessItem = (item, response, status, headers) => {
      console.log('Archivo subido exitosamente:', response);
    };
    this.uploader.onErrorItem = (item, response, status, headers) => {
      console.error('Error al subir el archivo:', response);
    };
  }
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public uploader: FileUploader = new FileUploader({
    url: `${environment.API}/rrhh/finiquito/crear`,
    itemAlias: 'finiquito',
    additionalParameter: {
      // contrato:JSON.parse(this.contrato)
    },
  });
  isUploading: boolean = false; // Estado de carga
  uploadMessage: string = ''; // Mensaje de estado
  // FILTERS
  trabajadorSelect: string = '';
  empresaSelect: string = '';
  estadoContratoSelect: string = '';
  // DROPDOWS
  trabajadoresFilter: any[] = [];
  empresaFilter: any[] = [];
  estadoContratoFilter: any[] = [];
  dataSource = new MatTableDataSource();
  lista_trabajadores: any;
  finiquitoCreado: boolean;
  viewFiniquitados: boolean = false;
  num_trab_finiquitados: any[] = [];
  displayedColumns = [
    'id',
    'rut',
    'nombres',
    'empresa',
    'estado_contrato',
    'acciones',
  ];

  ngOnInit(): void {
    this.TraerDatos();
  }
  idTrabajador: any;
  subir(content: any, id: any) {
    this.modalService.open(content, { size: 'xl', centered: true });
    this.idTrabajador = id;
  }
  onFileSelected(event: Event, id: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadFile(file, id);
    }
  }
  uploadFile(file: File, id: any) {
    this.isUploading = true; // Inicia el spinner
    this.uploadMessage = ''; // Resetea el mensaje

    // Aquí puedes implementar la lógica para subir el archivo usando HttpClient
    this.trabajadoresService.uploadFile(file, id).subscribe(
      (response) => {
        this.isUploading = false; // Detiene el spinner
        Swal.fire({
          toast: true,
          position: 'top-end', // Cambia la posición si lo deseas
          icon: 'success',
          title: 'Finiquito subido exitosamente',
          showConfirmButton: false,
          timer: 2000, // Dura 2 segundos
          timerProgressBar: true, // Muestra la barra de progreso
        });
      },
      (error) => {
        this.isUploading = false; // Detiene el spinner
        Swal.fire({
          toast: true,
          position: 'top-end', // Cambia la posición si lo deseas
          icon: 'error',
          title: 'Hubo un error al subir el finiquito',
          showConfirmButton: false,
          timer: 2000, // Dura 2 segundos
          timerProgressBar: true, // Muestra la barra de progreso
        });
      }
    );
  }

  TraerDatos(finiquitados: boolean = false) {
    this.trabajadoresService.TraerTrabajadores().subscribe((res) => {
      this.lista_trabajadores = res.data;
      if (!finiquitados) {
        this.lista_trabajadores = this.lista_trabajadores.filter(
          (x) => x.estado_contrato !== 'Finiquitado'
        );
      }
      this.lista_trabajadores.map(function (dato: any) {
        if (dato.estado_contrato == 1) {
          dato.estado_contrato = 'Contrato A Plazo Fijo ';
        }
        if (dato.estado_contrato == 2) {
          dato.estado_contrato = 'Contratado ';
        }
        if (dato.estado_contrato == 4) {
          dato.estado_contrato = 'Finiquitado';
        }
        return dato;
      });
      this.FiltrarDatos();
    });
  }
  FiltrarDatos() {
    let listaTrabajadorFilter = this.lista_trabajadores;
    if (this.empresaSelect !== '' && this.empresaSelect) {
      listaTrabajadorFilter = listaTrabajadorFilter.filter(
        (x) => x.Empresa_contratante.nombre === this.empresaSelect
      );
    }
    if (this.trabajadorSelect !== '' && this.trabajadorSelect) {
      listaTrabajadorFilter = listaTrabajadorFilter.filter(
        (x) => x.rut.toString() === this.trabajadorSelect
      );
    }
    if (this.estadoContratoSelect !== '' && this.estadoContratoSelect) {
      listaTrabajadorFilter = listaTrabajadorFilter.filter(
        (x) => x.estado_contrato === this.estadoContratoSelect
      );
    }
    // console.log({listaTrabajadorFilter}, this.trabajadorSelect, this.empresaSelect, this.estadoContratoSelect)
    this.configurarFilter(listaTrabajadorFilter);
    this.inicializarTabla(listaTrabajadorFilter);
  }

  inicializarTabla(lista_trabajadores: any[]) {
    this.dataSource = new MatTableDataSource(lista_trabajadores);
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filterLower = filter.toLocaleLowerCase().split(' ');

      const nombre: string =
        data.nombres.toLowerCase() + ' ' + data.apellidos.toLowerCase();
      const empresa: string = data.Empresa_contratante.nombre.toLowerCase();
      const estadoContrato: string = data.estado_contrato.toLowerCase();

      return (
        filterLower.every(
          (x) =>
            nombre.includes(x) ||
            empresa.includes(x) ||
            estadoContrato.includes(x)
        ) || filterLower === data.rut
      );
    };
    this.dataSource.paginator = this.paginator;
  }

  configurarFilter(lista_trabajadores: any[]) {
    const trabajadoresFilter = lista_trabajadores
      .map((x) => ({
        value: x.rut.toString(),
        text: x.nombres.toUpperCase() + ' ' + x.apellidos.toUpperCase(),
      }))
      .sort((a, b) => a.text.localeCompare(b.text));
    const empresaFilter = lista_trabajadores
      .map((x) => ({
        value: x.Empresa_contratante.nombre,
        text: x.Empresa_contratante.nombre.toUpperCase(),
      }))
      .sort((a, b) => a.text.localeCompare(b.value));
    const estadoContratoFilter = lista_trabajadores.map((x) => ({
      value: x.estado_contrato,
      text: x.estado_contrato.toUpperCase(),
    }));

    this.trabajadoresFilter = this.eliminarDuplicados(trabajadoresFilter);
    this.empresaFilter = this.eliminarDuplicados(empresaFilter);
    this.estadoContratoFilter = this.eliminarDuplicados(estadoContratoFilter);

    this.trabajadorSelect =
      this.trabajadoresFilter.length === 1
        ? this.trabajadoresFilter[0].value.toString()
        : null;
    this.empresaSelect =
      this.empresaFilter.length === 1 ? this.empresaFilter[0].value : null;
    this.estadoContratoSelect =
      this.estadoContratoFilter.length === 1
        ? this.estadoContratoFilter[0].value
        : null;
  }

  RestablecerFiltro() {
    this.trabajadorSelect = null;
    this.empresaSelect = null;
    this.estadoContratoSelect = null;
    this.TraerDatos(this.viewFiniquitados);
  }

  viewDatosFiniquitados() {
    this.TraerDatos(this.viewFiniquitados);
  }

  eliminarDuplicados(array: any[]) {
    const conjuntoDeValores = new Set();
    return array.filter((objeto) => {
      const valor = objeto['value'];
      if (!conjuntoDeValores.has(valor)) {
        conjuntoDeValores.add(valor);
        return true;
      }
      return false;
    });
  }

  Mostrar(content: any, id: any) {
    this.modalService.open(content, { fullscreen: true, scrollable: true });
    this.idTrabajador = id;
  }

  CerrarModal() {
    this.modalService.dismissAll();
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  updateCargaDatos() {
    this.TraerDatos();
  }

  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
